import type { DealStage, MainTab } from '@/types'

export type JourneyMacroId =
  | 'reuniao'
  | 'elaborar_proposta'
  | 'proposta'
  | 'teste_gratis'
  | 'contrato'
  | 'ganho'
  | 'perdido'
  | 'fechamento_futuro'
  | 'pausado'

export type JourneyMacroStage = {
  id: JourneyMacroId
  label: string
  color: string
  etapas: DealStage[]
  hint: string
}

/** Pipeline ativo — sem macro “Qualificação”; deals em qualificado entram em Reunião. */
export const JOURNEY_ACTIVE_MACROS: JourneyMacroStage[] = [
  {
    id: 'reuniao',
    label: 'Reunião',
    color: '#8B5CF6',
    etapas: ['qualificado', 'reuniao_agendada', 'reuniao_realizada'],
    hint: 'Agendar, confirmar e realizar reunião',
  },
  {
    id: 'elaborar_proposta',
    label: 'Elaborar Proposta',
    color: '#F59E0B',
    etapas: ['proposta_elaboracao'],
    hint: 'Montar e revisar proposta comercial',
  },
  {
    id: 'proposta',
    label: 'Proposta',
    color: '#14BDBD',
    etapas: ['proposta_enviada', 'renegociacao', 'ajustar_proposta'],
    hint: 'Enviar, negociar e ajustar proposta',
  },
  {
    id: 'teste_gratis',
    label: '30 dias Grátis',
    color: '#0EA5E9',
    etapas: ['teste_gratis'],
    hint: 'Cliente em teste. Retomar ao fim dos 30 dias',
  },
  {
    id: 'contrato',
    label: 'Contrato',
    color: '#2563EB',
    etapas: ['gerar_contrato', 'contrato_enviado', 'handover'],
    hint: 'Gerar contrato, assinatura e handover',
  },
]

export const JOURNEY_CLOSED_MACROS: JourneyMacroStage[] = [
  {
    id: 'ganho',
    label: 'Ganho',
    color: '#10B981',
    etapas: ['ganho'],
    hint: 'Negociações fechadas com sucesso',
  },
  {
    id: 'perdido',
    label: 'Perdido',
    color: '#EF4444',
    etapas: ['perdido'],
    hint: 'Negociações canceladas ou perdidas',
  },
]

export const JOURNEY_FUTURE_MACROS: JourneyMacroStage[] = [
  {
    id: 'fechamento_futuro',
    label: 'Fechamento futuro',
    color: '#6366F1',
    etapas: ['fechamento_futuro'],
    hint: 'Retomar em data programada',
  },
  {
    id: 'pausado',
    label: 'Pausado',
    color: '#6B7280',
    etapas: ['pausado'],
    hint: 'Negociação em pausa',
  },
]

export function getJourneyMacrosForTab(mainTab: MainTab): JourneyMacroStage[] {
  if (mainTab === 'closed') return JOURNEY_CLOSED_MACROS
  if (mainTab === 'future') return JOURNEY_FUTURE_MACROS
  return JOURNEY_ACTIVE_MACROS
}

const MACRO_BY_ETAPA = new Map<DealStage, JourneyMacroId>(
  [...JOURNEY_ACTIVE_MACROS, ...JOURNEY_CLOSED_MACROS, ...JOURNEY_FUTURE_MACROS].flatMap((macro) =>
    macro.etapas.map((etapa) => [etapa, macro.id] as const),
  ),
)

export function getJourneyMacroIdForEtapa(etapa: DealStage): JourneyMacroId | null {
  return MACRO_BY_ETAPA.get(etapa) ?? null
}
